import { lazy } from "react";

export { ABSENCE_TYPE_POLICY_PATH } from "./absence-type-list-path";
export const AbsenceTypeListPage = lazy(() => import("./absence-type-list"));
